import { render, staticRenderFns } from "./DataDescription.vue?vue&type=template&id=38dc7d6e"
import script from "./DataDescription.vue?vue&type=script&lang=js"
export * from "./DataDescription.vue?vue&type=script&lang=js"
import style0 from "./DataDescription.vue?vue&type=style&index=0&id=38dc7d6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports